module.exports = __webpack_public_path__ + "static/img/youyu.1a01945f.png";